import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Rect } from '../classes/rect.class';
import { ScrollService } from './scroll.service';

export type SwipeDirection = 'up' | 'down' | 'left' | 'right';

@Injectable({
  providedIn: 'root',
})
export class SwipeService {
  private scrollService = inject(ScrollService);
  private platformId = inject(PLATFORM_ID);
  pos: Rect;
  time: number;
  scrolled = false;
  onSwipe = new BehaviorSubject<SwipeDirection>(null);
  started = false;

  public start() {
    if (isPlatformServer(this.platformId)) return;
    if (this.started) return;
    this.started = true;
    window.addEventListener('touchstart', (event: TouchEvent) => {
      if (!event.changedTouches[0]) return;
      this.pos = Rect.fromTouch(event.changedTouches[0]);
      this.time = Date.now();
      this.scrolled = false;
    });

    window.addEventListener('touchend', (event: TouchEvent) => {
      if (this.scrolled) return;
      if (!this.pos) return;
      if (!event.changedTouches[0]) return;
      const moved = Rect.fromTouch(event.changedTouches[0]).subtract(this.pos);
      const duration = Date.now() - this.time;
      if (duration > 700) return;
      const axis = Math.abs(moved.x) > Math.abs(moved.y) ? 'x' : 'y';
      if (Math.abs(moved[axis]) < 30) return;
      const direction = axis === 'x' ? (moved[axis] > 0 ? 'left' : 'right') : moved[axis] > 0 ? 'down' : 'up';
      this.onSwipe.next(direction);
    });

    this.scrollService.onScroll.subscribe((event: Event) => {
      if (!event) return;
      const target = <HTMLElement>event.target;
      if (target?.toString().includes('HTMLDocument')) return;
      if (target.scrollTop < 0) return;
      this.scrolled = true;
    });
  }
}
